"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Element_1 = require("./Element");

exports.Post = function (_a) {
  var tenant = _a.tenant,
      post = _a.post;
  return react_1.default.createElement("div", null, post.elements && post.elements.map(function (element) {
    return react_1.default.createElement(Element_1.Element, {
      tenant: tenant,
      element: element,
      root: "Post"
    });
  }));
};